<div class="Customers customer-company ui-g">
  <div class="ui-g ui-fluid" style="width: 100%">
    <div class="ui-g-12">
      <div>
        <div class="ui-g ui-g-nopad form-group master-data">
          <div class="ui-g-12 ui-lg-8 ui-g-nopad">
            <h1 class="step-title">{{ titlePage | translate}}</h1>
          </div>
          <div class="ui-g-12 ui-lg-4 text-right">
            <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" label="Back"
              (click)="locationBack()"></button>
            <button pButton type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left"
              label="{{ 'common.save' | translate }}" (click)="save()" [disabled]="!formData.valid"></button>
          </div>
        </div>
      </div>
      <form *ngIf="formData" [formGroup]="formData">
        <div class="ui-g form-group master-data">

          <div class="ui-g-12 ui-g-nopad" style="display: flex; flex-wrap: nowrap;">
            <div [kv-form-element]="{ label: 'promotion.code', md: '4', required: true }">
              <input type="text" pInputText formControlName="code" />
              <div *ngIf="formData.get('code').invalid && (formData.get('code').dirty || formData.get('code').touched)"
                style="color: #e2001a; font-size: 12px; margin-top: 4px;">
                {{ 'common.required_error' | translate }}
              </div>
            </div>
            <div [kv-form-element]="{ label: 'promotion.description', md: '4' }">
              <input type="text" pInputText formControlName="description" />
            </div>
            
          </div>

          <div class="ui-g-12 ui-g-nopad" style="display: flex; flex-wrap: nowrap; margin-top: 10px;">
            <div [kv-form-element]="{label: 'Flg coupon scope', md: '2'}">
              <p-dropdown [options]="flgCouponScopes" formControlName="flg_coupon_scope" [style]="{'width':'100%'}"
                (onChange)="checkScopeUndefined($event.value)"></p-dropdown>
            </div>
            <div [kv-form-element]="{label: 'Flg coupon action', md: '2'}">
              <p-dropdown [options]="flgCouponActions" formControlName="flg_coupon_action" [style]="{'width':'100%'}"
                (onChange)="checkActionUndefined($event.value)"></p-dropdown>
            </div>
            <div [kv-form-element]="{label: 'Flg deployable', md: '2'}">
              <p-dropdown [options]="deployableOptions" formControlName="flg_deployable" [style]="{'width': '100%'}"
                placeholder="Non definito"></p-dropdown>
            </div>
            <div [kv-form-element]="{label: 'promotion.typePid', md: '2'}">
              <p-dropdown [options]="ochannel_type_pid" formControlName="typePid"
                [style]="{'width':'100%'}"></p-dropdown>
            </div>
          </div>

          <div class="ui-g-12 ui-g-nopad" style="display: flex; flex-wrap: nowrap; margin-top: 10px;">
            <div [kv-form-element]="{ label: 'Preview URL', md: '4' }">
              <input type="text" pInputText formControlName="preview_url" />
            </div>
            <div [kv-form-element]="{ label: 'Code Preview', md: '4' }">
              <input type="text" pInputText formControlName="code_preview" />
            </div>
          </div>

          <div class="ui-g-12 ui-g-nopad" style="display: flex; flex-wrap: nowrap; margin-top: 10px;">
            <div [kv-form-element]="{ label: 'promotion.maxReservableCoupons', md: '2' }">
              <input type="number" min="0" step="1" pInputText formControlName="max_reservable_coupons" />
              <small class="ui-message ui-messages-error" *ngIf="formData.controls['max_reservable_coupons'].invalid">{{ 'promotion.positiveIntegerRequired' | translate }}</small>
            </div>
            <div [kv-form-element]="{ label: 'promotion.maxUsableCoupons', md: '2' }">
              <input type="number" min="0" step="1" pInputText formControlName="max_usable_coupons" />
              <small class="ui-message ui-messages-error" *ngIf="formData.controls['max_usable_coupons'].invalid">{{ 'promotion.positiveIntegerRequired' | translate }}</small>
            </div>
            <div [kv-form-element]="{ label: 'promotion.maxRestorableCoupons', md: '2' }">
              <input type="number" min="0" step="1" pInputText formControlName="max_restorable_coupons" />
              <small class="ui-message ui-messages-error" *ngIf="formData.controls['max_restorable_coupons'].invalid">{{ 'promotion.positiveIntegerRequired' | translate }}</small>
            </div>
          </div>
          <div class="ui-g-12 ui-g-nopad" style="display: flex; flex-wrap: nowrap; margin-top: 10px;">
            <div [kv-form-element]="{label: '', md: '2'}">
              <p-checkbox label="Certifier" [(ngModel)]="certifier" [binary]="true"
                [ngModelOptions]="{standalone: true}"></p-checkbox>
            </div>
            <div [kv-form-element]="{label: '', md: '2'}">
              <p-checkbox label="Flg No Default" [(ngModel)]="flgNoDefault" [binary]="true"
                [ngModelOptions]="{standalone: true}"></p-checkbox>
            </div>
            <div [kv-form-element]="{label: '', md: '2'}">
              <p-checkbox label="Flg offline" [(ngModel)]="flgOffline" [binary]="true"
                [ngModelOptions]="{standalone: true}"></p-checkbox>
            </div>

          </div>
          <div class="ui-g-12 ui-g-nopad" style="display: flex; flex-wrap: nowrap; margin-top: 10px;">
            <div [kv-form-element]="{label: '', md: '2'}">
              <button type="button" class="layout-config-btn" pButton icon="fa fa-edit"
                label="{{ 'campaign.layout' | translate }}" (click)="openLayoutDialog(touchPoint)"></button>
            </div>
          </div>
          <div style="display: none;">
            <div [kv-form-element]="{label: 'promotion.otherFields', md: '12'}">
              <kv-promo-touch-point-privacy-fields [form]="formData" [actions]="actions" [privacyList]="privacyList"
                (deleteElement)="deletePrivacyList($event)">
              </kv-promo-touch-point-privacy-fields>
            </div>
            <button pButton type="button" class="k-generic-btn" icon="fa fa-plus-circle"
              label="{{'common.add' | translate}}" (click)="addPrivacy()"></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Dialog Configurazione Layout -->
<app-touch-point-layout-dialog [visible]="showLayoutDialog && !!layoutData" [layoutData]="layoutData"
  [activeFields]="activeFields" [inactiveFields]="inactiveFields" [renderSchemaViewer]="renderSchemaViewer"
  [missingLayout]="missingLayout" (close)="closeLayoutDialog()" (save)="saveLayoutStructure()"
  (removeField)="removeFieldFromSchema($event)" (addField)="addFieldToSchema($event)">
</app-touch-point-layout-dialog>


// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/components/touchPointDetail.component.html